import { BaseRepository } from "@/repositories/base-repository"
import type { IProduct } from "@/interfaces/api/product.interface"

export class ProductRepository extends BaseRepository<IProduct> {
  protected resourcePath = "planning/products"
}
